import React from 'react';

import cls from './Header.module.scss'

interface IHeaderProps {
    left?: React.ReactNode;
    title?: React.ReactNode;
    right?: React.ReactNode;
}

export const Header = ({left, title, right}: IHeaderProps) => (
        <header className={cls.header}>
            <div className={cls.left}>{left}</div>
            <div className={cls.title}>{title}</div>
            <div className={cls.right}>{right}</div>
        </header>
    )